import { domain } from 'modules/data';

export enum SignInPostActionType {
    Connect = 'connect',
    Disconnect = 'disconnect',
}

export type SignInPostAction =
    | {
          type: SignInPostActionType.Connect;
          externalOrgId?: string;
      }
    | {
          type: SignInPostActionType.Disconnect;
          externalOrgId: string;
      };

export interface SignInWithOptions {
    startingPoint: domain.SsoStartingPoint;
    app?: domain.SsoLoginApplication;
    postAction?: SignInPostAction;
    afterLoginRedirectUrl?: string;
    tenantId?: string;
}
